import React from 'react';
import { FormattedNumber } from 'react-intl';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import Translation from '@swf/components/Translation/Translation';
import type { Currency } from '@swf/core/enums';
import type { TranslationTag } from '@swf/core/types/i18n';

import styles from './FeatureDetails.scss';

export enum FormatType {
  String = 'string',
  Currency = 'currency',
  Percentage = 'percent',
  Translation = 'translation'
}

export interface Props {
  format: string;
  title: TranslationTag;
  value: string | number | TranslationTag[];
  currency?: Currency;
}

const FeatureDetails: React.FC<Props> = ({ title, value, format, currency }) => (
  <>
    <span className={styles.infoDescription}>
      <Translation {...title} />:{' '}
    </span>
    <span className={styles.infoValue}>
      {format === FormatType.String && value}
      {format === FormatType.Translation &&
        (value as TranslationTag[]).map((theObj, i) => [
          i > 0 && ', ',
          <Translation key={i} {...theObj} />
        ])}
      {format === FormatType.Percentage && (
        <FormattedNumber
          style="percent"
          maximumFractionDigits={2}
          value={(value as number) / 100}
        />
      )}
      {format === FormatType.Currency && (
        <CurrencyAmount value={parseFloat(value as string)} currency={currency} />
      )}
    </span>
    <br />
  </>
);

export default FeatureDetails;
